import classnames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../Button/Button'

import styles from './ConfirmDialog.module.scss'

type ConfirmDialogProps = React.PropsWithChildren<{
  close: (result: boolean) => void
  yesLabel?: string
  noLabel?: string
  className?: string
}>

export default React.memo(function ConfirmDialog({
  children,
  close,
  yesLabel,
  noLabel,
  className,
}: ConfirmDialogProps) {
  const { t } = useTranslation()

  return (
    <div className={classnames(styles.ConfirmDialog, className)}>
      {children}
      <div className={styles.buttons}>
        <Button onClick={() => close(true)}>{yesLabel || t('generic cta.yes')}</Button>
        <Button onClick={() => close(false)}>{noLabel || t('generic cta.no')}</Button>
      </div>
    </div>
  )
})
